import { TableCell, Button } from '@mui/material';
import { InvoiceRowDto } from '@sr/dto';

type PlacementButtonProps = {
  showButton: boolean;
  text: string;
  variant: 'text' | 'outlined' | 'contained';
}

export const PlacementCell = ({ showButton, text, variant, onPlaceClick }: PlacementButtonProps & { onPlaceClick: () => void }) => {
  return (
    <TableCell>
      {showButton && <Button
        size='small'
        variant={variant}
        onClick={onPlaceClick}
        sx ={{ whiteSpace:'nowrap' }}
      >
        {text}
      </Button>}
    </TableCell >);
};

export const usePlacementCell = (isNewRow: boolean, row: InvoiceRowDto, isClientInvoice: boolean) => {
  const buttonProps: PlacementButtonProps = {
    text: '',
    variant: 'text',
    showButton: !isNewRow
  };

  let disableDelete = false;

  if (isClientInvoice) {
    buttonProps.text = row.linkedPurchase ? `Заявка № ${row.linkedPurchase.id}` : 'Разместить';
    buttonProps.variant = row.linkedPurchase ? 'text' : 'outlined';
    disableDelete = !!row.linkedPurchase;
  }
  else {
    buttonProps.text = row.linkedPurchase ? 'Отвязать' : 'Привязать';
    buttonProps.variant = row.linkedPurchase ? 'outlined' : 'contained';
    disableDelete = !!row.linkedPurchase;
  }

  return {
    buttonProps,
    disableDelete,
  };
};
